export default __webpack_public_path__ + "static/media/heco-logo.d9d231e5.png";